/* eslint no-underscore-dangle: 0 */

import $ from 'jquery';

const newsletterSignup = () => {
    const $subscriptionForm = $('.s-newsletter-signup-form');

    if ($subscriptionForm.length === 0) return;

    $subscriptionForm.each(() => {
        const $inputTxt = $('input[type=text]', this);
        const $submitBtn = $subscriptionForm.find('input[type=submit]', this);
        const $responseMsg = $('.response-msg', this);
        const $openModalSubscription = $('.js-open-modal', this);

        const validateInputTxt = element => {
            $(element).each(i => {
                const requiredField = $(element[i]).attr('placeholder');

                if (requiredField.indexOf('*') !== -1) {
                    if ($(element[i]).val() === '') {
                        $(element[i]).addClass('error');
                    } else {
                        $(element[i]).removeClass('error');
                    }
                }
            });

            if ($('.error').length > 0) {
                return false;
            }

            return true;
        };

        const submitSubscription = ev => {
            const isValid = validateInputTxt($inputTxt);
            const submitBtnName = ev.target.getAttribute('name');

            if (isValid) {
                $responseMsg.removeClass('invalid');

                window.__doPostBack(submitBtnName, '');
            } else {
                $responseMsg.addClass('invalid');
                ev.preventDefault();
            }
        };

        const clearInput = () => {
            $inputTxt.val('');

            if ($('.invalid').length > 0 || $('.error').length > 0) {
                $responseMsg.removeClass('invalid');
                $inputTxt.removeClass('error');
            }
        };

        $submitBtn.on('click', e => {
            submitSubscription(e);
        });

        $openModalSubscription.on('click', () => {
            clearInput();
        });
    });
};

// doc ready
$(() => {
    newsletterSignup();
});



// WEBPACK FOOTER //
// ./src/sections/newsletter-signup/s-newsletter-signup.js